var perimeter = function perimeter(radius) {
  return 2 * Math.PI * radius;
};

export default {
  perimeter: perimeter
};